/**
 * @generated SignedSource<<ddaf36a81b8482b90b887b21b2b29090>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductPackageItem_package$data = {
  readonly __typename: string;
  readonly displayInApp: {
    readonly displayName: string;
  } | null | undefined;
  readonly id: string | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"PackageBenefitsSummary_package" | "PackageItemActions_package" | "PackagePriceDisplay_package">;
  readonly " $fragmentType": "StoreProductPackageItem_package";
};
export type StoreProductPackageItem_package$key = {
  readonly " $data"?: StoreProductPackageItem_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductPackageItem_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductPackageItem_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DisplayInApp",
      "kind": "LinkedField",
      "name": "displayInApp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackagePriceDisplay_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageBenefitsSummary_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageItemActions_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "c2ad3488a0f74236032c64774c81c8b0";

export default node;
